import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const PlusIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 3C7.25 2.58579 7.58579 2.25 8 2.25H12C12.4142 2.25 12.75 2.58579 12.75 3V7.25H17C17.4142 7.25 17.75 7.58579 17.75 8V12C17.75 12.4142 17.4142 12.75 17 12.75H12.75V17C12.75 17.4142 12.4142 17.75 12 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17V12.75H2.99998C2.80106 12.75 2.6103 12.671 2.46965 12.5303C2.32899 12.3897 2.24998 12.1989 2.24998 12L2.24998 8C2.24998 7.80109 2.32899 7.61032 2.46965 7.46967C2.6103 7.32902 2.80106 7.25 2.99998 7.25L7.25 7.25V3ZM8.75 3.75V8C8.75 8.19891 8.67098 8.38968 8.53033 8.53033C8.38968 8.67098 8.19891 8.75 8 8.75L3.74998 8.75L3.74998 11.25H8C8.41421 11.25 8.75 11.5858 8.75 12V16.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25H16.25V8.75H12C11.5858 8.75 11.25 8.41421 11.25 8V3.75H8.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
